import { Component, OnInit } from '@angular/core';
import { EmailValidator, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { defer, finalize, forkJoin, switchMap } from 'rxjs';
import { ComunesService } from 'src/app/services/comunes.service';
import { DenunciasService } from 'src/app/services/denuncias.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { IngresoInfoComponent } from '../modals/ingreso-info/ingreso-info.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import * as moment from 'moment';
import { DocumentosService } from '../../services/documentos.service';
import { v1 as uuid } from 'uuid';
import { emailValidator, rutValidator } from '../../shared/validators';
import { AlertaComponent } from '../modals/alerta/alerta.component';

@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.css']
})
export class IngresoComponent implements OnInit {
  formDenuncia: FormGroup;
  recaptchaSubscription: any;
  regiones: any[] = [];
  comunas: any[] = [];
  fechaFin : any;
  propiedades: any[] = [];
  modalRef: NgbModalRef | undefined;
  isCollapsed: boolean = false;
  documentos: any = [];
  involucran :  any = [];

  get propiedadesForm() {
    return this.formDenuncia.get('propiedades') as FormControl;
  }

  get anonimo() {
    return this.formDenuncia.get('anonimo') as FormControl
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private denunciasService: DenunciasService,
    private comunesService: ComunesService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
    private documentosService : DocumentosService
  ) {
    this.formDenuncia = this.fb.group({
      rut: this.fb.control('', [ rutValidator]),
      nombre: this.fb.control(''),
      apellidos: this.fb.control(''),
      email: this.fb.control('', emailValidator()),
      fono: this.fb.control(''),
      forma: this.fb.control('', Validators.required),
      descripcion: this.fb.control('', Validators.required),
      involugrados: this.fb.control('', Validators.required),
      fechaIngreso: this.fb.control(new Date(), Validators.required),
      fechaEvento: this.fb.control(null, Validators.required),
      anonimo: this.fb.control(true),
      codigo: this.fb.control(''),
      regiId: this.fb.control('', Validators.required),
      comuId: this.fb.control(132101),
      restId: this.fb.control(0, Validators.required),
      fiscal: this.fb.control(false),
      token: this.fb.control(''),
      estId: this.fb.control(1, Validators.required),
      propiedades: this.fb.control([]),
      documentos: this.fb.control([]),
      invoId: this.fb.control('', Validators.required),
      organizacion: this.fb.control(true),
      trabOrganizacion: this.fb.control(''),
      trabDepartamento: this.fb.control(''),
      trabOtro : this.fb.control(''),
    })
  }



  ngOnInit(): void {
    this.fechaFin = moment().format('YYYY-MM-DD');
    this.obtenerRegiones();
    this.obtenerPropiedadesDenuncias();
    this.obtenerInvolucran();
    this.formDenuncia.valueChanges.subscribe(console.log)
  }

  ngOnDestroy() {
    if (this.recaptchaSubscription) {
      this.recaptchaSubscription.unsubscribe();
    }
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'hidden';
    }
  }

  ngAfterViewInit() {
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'visible';
    }
  }

  obtenerPropiedadesDenuncias() {
    this.spinner.show();
    this.denunciasService.obtenerPropiedadesDenuncias()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((result) => {
        this.propiedades = result;
      })
  }

  editarPropiedad(propiedad: any, event: MatCheckboxChange) {
    const value = this.propiedadesForm.value as any[];
    if (event.checked) {
      value.push(propiedad)
    } else {
      const idx = value.findIndex((v) => v.proId == propiedad.proId);
      value.splice(idx, 1);
    }

    const anonimo = value.some((propiedad) => !propiedad.anonimo);
    if(anonimo){
      this.formDenuncia.get('rut')?.setValidators([Validators.required, rutValidator]);
    }else{
      this.formDenuncia.get('rut')?.setValidators(rutValidator);
    }

    this.propiedadesForm.setValue(value);
  }

  obtenerRegiones() {
    this.spinner.show();
    this.comunesService.listarRegiones()
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((result) => {
        this.regiones = result;
      });
  }

  obtenerComunas() {
    const { regiId } = this.formDenuncia.value
    this.spinner.show();
    this.comunesService.listarComunasRegion(regiId)
      .pipe(finalize(() => this.spinner.hide()))
      .subscribe((result) => {
        this.comunas = result;
      })
  }

  async obtenerCorrelativo() {
    return new Promise(resolve => {
      this.spinner.show();
      this.denunciasService.obtenerCorrelativo().subscribe({
        next: (resp: any) => {
          this.spinner.hide();
          resolve(resp.codigo);
        }, error: (err: any) => {
          this.spinner.hide();
        }
      })
    })
  }

  denunciaPrivada(event : any){
   if(!event){
    this.formDenuncia.get('rut')?.setValidators([Validators.required,rutValidator]);
    this.formDenuncia.get('rut')?.updateValueAndValidity();
    this.formDenuncia.get('nombre')?.setValidators(Validators.required);
    this.formDenuncia.get('nombre')?.updateValueAndValidity();
    this.formDenuncia.get('apellidos')?.setValidators(Validators.required);
    this.formDenuncia.get('apellidos')?.updateValueAndValidity();
    this.formDenuncia.get('email')?.setValidators([emailValidator()]);
    this.formDenuncia.get('email')?.updateValueAndValidity();
   }else{
    this.formDenuncia.get('rut')?.setValidators(rutValidator);
    this.formDenuncia.get('rut')?.updateValueAndValidity();
    this.formDenuncia.get('nombre')?.setValidators([]);
    this.formDenuncia.get('nombre')?.updateValueAndValidity();
    this.formDenuncia.get('apellidos')?.setValidators([]);
    this.formDenuncia.get('apellidos')?.updateValueAndValidity();
    this.formDenuncia.get('email')?.setValidators([emailValidator()]);
    this.formDenuncia.get('email')?.updateValueAndValidity();
   }

  }

  async enviarDenuncia() {
    try {
      this.formDenuncia.markAllAsTouched();
      const propiedades = this.formDenuncia.value.propiedades.filter((propiedad:any) => !propiedad.anonima);
      if(this.formDenuncia.value.anonimo && propiedades.length > 0){
        const propiedad = propiedades.find((propiedad:any) => propiedad.propiedadBloqueos.length > 0)
        if(propiedad){
          this.modalRef = this.modalService.open(AlertaComponent, { backdrop: 'static' });
          this.modalRef.componentInstance.data = { alerta: propiedad.propiedadBloqueos[0].descripcion };
          this.modalRef.result.then(() => {
            this.formDenuncia.get('anonimo')?.setValue(false);
            this.denunciaPrivada(false);
            window.scrollTo({top: 0, behavior: 'smooth'});
          })
        }
        return;
      }

      if (!this.formDenuncia.valid) {
        this.toastrService.warning("Debe completar los campos del formulario");
        return;
      }
  
      if(this.formDenuncia.value.propiedades.length == 0){
        this.toastrService.warning("Debe seleccionar por lo menos una propiedad");
        return;
      }

      if(!this.formDenuncia.value.anonimo){  
        if(this.formDenuncia.value.email === '' && this.formDenuncia.value.fono === ''){
          this.toastrService.warning("Debe ingresar un correo o un telefono");
          return;
        }
      }
  
      this.recaptchaSubscription = defer(() => this.spinner.show())
        .pipe(
          switchMap(() => this.recaptchaV3Service.execute('registerCustomer')),
          finalize(() => this.spinner.hide())
        ).subscribe({
          next: async (resultado: any) => {
            if (resultado) {
              let codigo : any = await this.obtenerCorrelativo();
              this.spinner.show();
              this.formDenuncia.get('codigo')?.setValue(codigo);
              this.formDenuncia.get('token')?.setValue(uuid());


              const { propiedades, ...form } = this.formDenuncia.value;

              const newPropiedades = propiedades.map((prop: any) => { return { proId: prop.proId, otro: prop.proId == 0 ? prop.descripcion : '' } });
            
              this.denunciasService.guardarDenuncia({ ...form, propiedades: newPropiedades })
                .subscribe({
                  next: async (data) => {
                    console.log(newPropiedades);
                    if(this.documentos.length > 0){
                      await this.guardarArchivos(codigo, data)
                    }
                    this.spinner.hide();
                    this.modalRef = this.modalService.open(IngresoInfoComponent, { backdrop: 'static' });
                    this.modalRef.componentInstance.data = this.formDenuncia.value;
                    this.modalRef.result.then((result) => {
                      if (result.estado) {
                        this.router.navigate(['home']);
                      }
                    })
                  },
                  error: (err) => {
                    this.spinner.hide();
                    console.log(err);
                    this.toastrService.error("Ha ocurrido un error en el proceso");
                  }
                });

            }
          },
          error: (err) => {
            this.toastrService.error("Ocurrio un problema con el Captha")

          }
      });


      /*
       */
    } catch (error) {
      this.spinner.hide();
      console.log(error);

      this.toastrService.error("Ha ocurrido un error en el proceso");
    }

  }

  agregarOtro(valor: string) {
    const value = this.propiedadesForm.value as any[];
    const idx = value.findIndex((v) => v.proId == 0);
    if (idx != -1) {
      value[idx].descripcion = valor
    }

    this.propiedadesForm.setValue(value);
  }

  cancelar() {
    this.router.navigate(['/home']);
  }

  showFile(file: any) {
    file.click();
  }


  async cargardocumento(event: any, tipoDoc: any) {
    console.log(event);
    //this.spinner.show();
    try {
      for (const file of event.target.files) {
        this.documentos.push({nombre : file.name.toString().replace(/ /g, '_') , file : file , type : file.type , ruta : '', fecha : moment(), tipo : tipoDoc, denId : null})
      }
      console.log(this.documentos);

    }
    catch (error: any) {
      await this.spinner.hide();
      console.log(error);
      this.toastrService.error("Ha ocurrido un error");

    }
  }


  formatoFecha(fecha: string): string {
    if (fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    }

    return '';
  }

  eliminarDoc(doc : any , index : any){
    console.log(doc);
    this.documentos.splice(index, 1)
  }

 async  guardarArchivos(codigo : string, data : any){
  this.spinner.show();
  try{
    for(let doc of this.documentos){
      const tipoDoc = doc.tipo;
      console.log(doc)
    
        const nombre = doc.file.name.toString().replace(/ /g, '_')
        const fileName = `Documentos/${codigo}/${tipoDoc}/${Date.now()}_${doc.file.name.toString().replace(/ /g, '_')}`;
        const fileData: any = {
          key: fileName,
          metodo: 'put',
          tipo: doc.type
        };

        const url = await this.documentosService.getSignedUrl(fileData).toPromise();
        await this.documentosService.uploadFileS3(doc.file, url.message, doc.type).toPromise();

       // archivo = fileName;
        console.log(fileName);
        const docsave = {
          docuId: null,
          nombre: nombre,
          ruta: fileName,
          fecha: new Date(),
          tipo: tipoDoc,
          denId: data.denId
        } 
        this.documentosService.guardarDocumentos(docsave).subscribe({
          next: (data) => {
            this.spinner.hide();
          },
          error: (err) => {
            this.spinner.hide();
            console.log(err);
          }
        }) 
       


    }

  }catch(err){
    console.log(err);
  }

          
  }

  verpropiedad(event : any ){
    return event?._isCollapsed;
  }

  obtenerInvolucran() {
    this.spinner.show();
    this.denunciasService.listarInvolucran().subscribe({
      next: (invo: any) => {
        this.spinner.hide();
        this.involucran = invo;
        console.log(invo);
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    })
  }


}
